import { toast } from "react-toastify";
import { setTitle } from "../../../../helpers/MetaTag";
import { handleFilterChange } from "../../../../helpers";
import DeleteModal from "../../../common/DeleteModal";

import { useDebounce } from "../../../../hooks/useDebounce";
import LimitSelect from "../../../elements/LimitSelect";
import { useEffect, useState } from "react";
import Search from "../../../form/Search";
import Table from "../../../elements/table/Table";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Button from "../../../form/Button";
import {
  collectionDelete,
  collectionList,
  collectionStatusChange,
} from "../../../../services/collectionService";
import dayjs from "dayjs";
import ActionBar from "../../../elements/ActionBar";
import { lngDetect } from "../../../../helpers/lngDetect";
import Badge from "../../../elements/Badge";
import ManageCollectionDrawer from "../../admin/Collection/Drawer/ManageCollectionDrawer";
import { tableFilter } from "../../../../helpers/tableFilterOptions";
import Input from "../../../form/Input";
import RengePickerInput from "../../../form/RengePickerInput";
import { organizationList } from "../../../../services/organizationService";
import PopoverDropdown from "../../../elements/PopoverDropdown";
import Select from "../../../form/select/Select";
import { useOrganization } from "../../../../context/OrganizationContext";
import Dropdown from "../../../form/Dropdown";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const statusList = [
  { name: "onsale", value: "onsale", type: "checkbox" },
  { name: "ticketatdoor", value: "ticketatdoor", type: "checkbox" },
  { name: "soldout", value: "soldout", type: "checkbox" },
  { name: "cancelled", value: "cancelled", type: "checkbox" },
  { name: "postponed", value: "postponed", type: "checkbox" },
  { name: "draft", value: "draft", type: "checkbox" },
];

const eventItems = [
  {
    _id: "1",
    name: "Test1",
    link: "/",
  },
  {
    _id: "2",
    name: "Test2",
    link: "/",
  },
  {
    _id: "3",
    name: "Test3",
    link: "/",
  },
];

// Enhanced styling functions for status and visibility
const getStatusStyle = (status) => {
  const statusLower = status?.toLowerCase();
  const statusStyles = {
    onsale: {
      backgroundColor: "#D1FAE5",
      color: "#047857",
      borderColor: "#10B981",
    },
    ticketatdoor: {
      backgroundColor: "#DBEAFE",
      color: "#1D4ED8",
      borderColor: "#3B82F6",
    },
    soldout: {
      backgroundColor: "#FEE2E2",
      color: "#DC2626",
      borderColor: "#EF4444",
    },
    cancelled: {
      backgroundColor: "#F3F4F6",
      color: "#374151",
      borderColor: "#6B7280",
    },
    postponed: {
      backgroundColor: "#FEF3C7",
      color: "#D97706",
      borderColor: "#F59E0B",
    },
    draft: {
      backgroundColor: "#FCE7F3",
      color: "#BE185D",
      borderColor: "#EC4899",
    },
    active: {
      backgroundColor: "#D1FAE5",
      color: "#047857",
      borderColor: "#10B981",
    },
    inactive: {
      backgroundColor: "#FEE2E2",
      color: "#DC2626",
      borderColor: "#EF4444",
    },
  };

  return (
    statusStyles[statusLower] || {
      backgroundColor: "#F3F4F6",
      color: "#374151",
      borderColor: "#6B7280",
    }
  );
};

const getVisibilityStyle = (visibility) => {
  const visibilityLower = visibility?.toLowerCase();
  const visibilityStyles = {
    public: {
      backgroundColor: "#D1FAE5",
      color: "#047857",
      borderColor: "#10B981",
    },
    private: {
      backgroundColor: "#FEE2E2",
      color: "#DC2626",
      borderColor: "#EF4444",
    },
  };

  return (
    visibilityStyles[visibilityLower] || {
      backgroundColor: "#F3F4F6",
      color: "#374151",
      borderColor: "#6B7280",
    }
  );
};

const Collections = () => {
  const { t } = useTranslation();
  const { organizations, selectedOrganization } = useOrganization();
  const { lang } = useSelector((state) => state?.langProvider);

  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [organizationKeyword, setuserKeyword] = useState("");
  const organizationSearch = useDebounce(organizationKeyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [organizationFilters, setOrganizationFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });

  const {
    data: organizationData,
    isLoading: organizationLoading,
    isFetching: organizationFetching,
  } = useQuery({
    queryKey: ["organization", organizationSearch, organizationFilters],
    queryFn: async () => {
      const res = await organizationList({
        ...organizationFilters,
        ...(organizationSearch && { keyword: organizationSearch }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["Collection", filters, search, selectedOrganization],
    queryFn: async () => {
      const res = await collectionList({
        ...filters,
        organization: selectedOrganization,
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  //   Collection status change handler =================>
  // const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
  //   useMutation({
  //     mutationFn: async ({ id, status }) => {
  //       queryClient.setQueryData(
  //         ["Collection", filters, search, selectedOrganization],
  //         (state) => {
  //           if (state) {
  //             let stateData = JSON.parse(JSON.stringify(state?.data));
  //             stateData = (stateData || []).map((elm) =>
  //               elm?._id === id
  //                 ? {
  //                     ...elm,
  //                     status: status,
  //                   }
  //                 : elm
  //             );
  //             return { ...state, data: stateData };
  //           }
  //         }
  //       );
  //       const res = await collectionStatusChange({
  //         ids: [id],
  //         status: status,
  //       });
  //       return { res, payload: { id, status } };
  //     },
  //     onSuccess: ({ res, payload }) => {
  //       if (res?.status === 200) {
  //         toast.success("Status updated successfully!");
  //       } else {
  //         queryClient.setQueryData(
  //           ["Collection", filters, search, selectedOrganization],
  //           (state) => {
  //             if (state) {
  //               let stateData = JSON.parse(JSON.stringify(state?.data));
  //               stateData = (stateData || []).map((elm) =>
  //                 elm?._id === payload?.id
  //                   ? {
  //                       ...elm,
  //                       status: payload?.status,
  //                     }
  //                   : elm
  //               );
  //               return { ...state, data: stateData };
  //             }
  //           }
  //         );
  //         toast.warning(res?.message || "Failed to update status");
  //       }
  //     },
  //     onError: (error) => {
  //       toast.error("Failed to update status");
  //       console.log(error);
  //     },
  //   });

  // Status cycle function
  const getNextStatus = (currentStatus) => {
    const statusOrder = [
      "onsale",
      "ticketatdoor",
      "soldout",
      "cancelled",
      "postponed",
      "draft",
    ];
    const currentIndex = statusOrder.indexOf(currentStatus);
    const nextIndex = (currentIndex + 1) % statusOrder.length;
    return statusOrder[nextIndex];
  };

  const tableHeadData = [
    {
      _id: 1,
      name: t("Name"),
      align: "left",
    },
    {
      _id: 4,
      name: t("Description"),
      align: "left",
    },

    {
      _id: "organizers",
      name: t("organizers"),
      align: "left",
      ...tableFilter({
        filterKey: "organizers",
        filterList: organizationData?.data?.map((item) => ({
          name: lngDetect(item?.name),
          value: item?._id,
          type: "checkbox",
        })),
        setFilters: (val) => {
          setFilters((pre) => ({ ...pre, ...val, page: 1 }));
        },
      }),
    },
    {
      _id: 6,
      name: t("Status"),
      align: "left",
      ...tableFilter({
        filterKey: "status",
        filters,
        setFilters: (val) => {
          setFilters((pre) => ({ ...pre, ...val, page: 1 }));
        },
        filterList: statusList,
      }),
    },
    {
      _id: "visibility",
      name: t("visibility"),
      align: "left",
      ...tableFilter({
        filterKey: "visibility",
        filters,
        setFilters: (val) => {
          setFilters((pre) => ({ ...pre, ...val, page: 1 }));
        },
        filterList: [
          { name: "public", value: "public", type: "checkbox" },
          { name: "private", value: "private", type: "checkbox" },
        ],
      }),
    },
    {
      _id: 3,
      name: t("Created On"),
      align: "left",
    },
    {
      _id: 8,
      name: t("Action"),
      align: "left",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    const statusStyle = getStatusStyle(item?.status);
    const visibilityStyle = getVisibilityStyle(item?.visibility);

    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "user",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: lngDetect(item?.name) || "-",
          image: item?.logo?.url,
          isTooltip: false,
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            item?.description?.length > 25
              ? `${lngDetect(item.description).slice(0, 25)}...`
              : lngDetect(item?.description) || "-",
        },
        {
          _id: 6,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: lngDetect(item?.organizationData?.name) || "-",
        },
        {
          _id: 6,
          type: "text",
          align: "left",
          cellClass: "!min-w-[120px]",
          data: (
            <span
              className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border transition-all duration-200 select-none hover:brightness-95 hover:scale-105`}
              style={{
                backgroundColor: statusStyle.backgroundColor,
                color: statusStyle.color,
                borderColor: statusStyle.borderColor,
              }}
              title="Click to cycle through status options"
            >
              {item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)}
            </span>
          ),
        },
        {
          _id: "visibility",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <span
              className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border transition-all duration-200 select-none hover:brightness-95 hover:scale-105`}
              style={{
                backgroundColor: visibilityStyle.backgroundColor,
                color: visibilityStyle.color,
                borderColor: visibilityStyle.borderColor,
              }}
              title="Click to toggle visibility"
            >
              {item?.visibility?.charAt(0)?.toUpperCase() +
                item?.visibility?.slice(1)}
            </span>
          ),
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: dayjs(item?.createdAt).format("MMM DD, YYYY") || "-",
        },
        {
          _id: 9,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            {
              _id: 9.1,
              name: t("Edit"),
              icon: "fa-regular fa-pen-to-square",
              onClick: () => {
                setModalOpen({
                  isOpen: true,
                  data: { ...item, organization: selectedOrganization },
                });
              },
              standout: false,
            },
            {
              _id: 9.2,
              name: t("Delete"),
              icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  useEffect(() => {
    const handleAddEvent = (e) => {
      pageManageResponse(e?.detail);
    };

    window.addEventListener("addCollection", handleAddEvent);

    return () => {
      window.removeEventListener("addCollection", handleAddEvent);
    };
  }, []);

  // add or edit page =================>
  function pageManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          queryClient.setQueryData(
            ["Collection", filters, search, selectedOrganization],
            (state) => {
              if (state) {
                let stateData = JSON.parse(JSON.stringify(state?.data));
                stateData = [...stateData, res?.data];
                return { ...state, data: stateData };
              }
            }
          );
          if (data?.metadata?.totalDocs > filters?.limit) {
            queryClient.invalidateQueries([
              "Collection",
              filters,
              search,
              selectedOrganization,
            ]);
          }
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        queryClient.setQueryData(
          ["Collection", filters, search, selectedOrganization],
          (state) => {
            if (state) {
              let stateData = JSON.parse(JSON.stringify(state?.data));
              stateData = stateData?.map((item) =>
                item?._id === res?.data?._id ? { ...item, ...res?.data } : item
              );
              return { ...state, data: stateData };
            }
          }
        );
        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries([
            "Collection",
            filters,
            search,
            selectedOrganization,
          ]);
        }
      }
      setModalOpen({ isOpen: false, data: null });
      setTimeout(() => {
        queryClient.invalidateQueries([
          "Collection",
          filters,
          search,
          selectedOrganization,
        ]);
      }, 200);
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   Collection delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await collectionDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return {
        res,
        payload: Array.isArray(payload) ? payload : [payload],
      };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        queryClient.setQueryData(
          ["Collection", filters, search, selectedOrganization],
          (state) => {
            if (state) {
              let stateData = JSON.parse(JSON.stringify(state?.data));
              stateData = stateData?.filter(
                (item) => !payload?.includes(item?._id)
              );

              return { ...state, data: stateData };
            }
          }
        );

        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries([
            "Collection",
            filters,
            search,
            selectedOrganization,
          ]);
        }
        setTimeout(() => {
          queryClient.invalidateQueries([
            "Collection",
            filters,
            search,
            selectedOrganization,
          ]);
        }, 200);
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const options = [
    {
      id: "userDelete",
      icon: "fa-regular fa-trash-can",
      tooltip: "User Delete",
    },
  ];

  function actionHandler(val) {
    switch (val) {
      case "userDelete":
        setDeleteModal({
          isOpen: true,
          data: { _id: selectedItems },
        });
        break;

      default:
        break;
    }
  }

  return (
    <div className="w-full flex flex-col pb-10 bg-white rounded-md">
      <div className="space-y-4 md:space-y-8 py-8 px-0 md:px-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-2">
          <h2 className="text-xl md:text-2xl text-slate-900 font-bold font-Montserrat uppercase">
            {t("Collection Overview")}
          </h2>
          <div className="flex items-center gap-3 w-full md:w-auto">
            <div className="relative w-full">
              <Search
                placeholder={t("Search here")}
                divClasses={"border-slate-300 bg-slate-50"}
                search={(val) => {
                  setKeyword(val);
                  handleFilterChange("page", 1, setFilters);
                }}
              />
            </div>
          </div>
        </div>
        <Table
          tableHeadData={tableHeadData}
          tableData={tableData}
          isLoder={isLoading}
          pageCount={data?.metadata?.totalPages}
          currentPage={filters?.page}
          onPageChange={(val) => {
            handleFilterChange("page", val, setFilters);
            setSelectedItems([]);
          }}
          handleOrdering={(val) => {
            console.log(val);
          }}
          isFetching={isFetching}
          isOrderingDisabled={true}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          tableActionDropdownContainer={"!w-48"}
        />
      </div>
      <ManageCollectionDrawer
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={pageManageResponse}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Collections;
